<h1>Import Tool</h1>
<div class="importStatus" *ngIf="importStatus">
  Progress: {{importStatus.progress}}%
</div>
<button (click)="startImport()">Start Import</button>
